module.exports = __webpack_public_path__ + "static/media/pharma2.b29567d3.jpg";